<template>
  <div class="audio-spectrum" :style="spectrumStyles">
    <div class="spectrum-container">
      <div class="spectrum-bar" v-for="i in 32" :key="i" :style="getBarStyle(i)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioSpectrum',
  props: {
    isPlaying: {
      type: Boolean,
      default: false,
    },
    primaryColor: {
      type: String,
      default: '#ff6600',
    },
  },
  computed: {
    spectrumStyles() {
      return {
        '--primary-color': this.primaryColor,
      };
    },
  },
  methods: {
    getBarStyle(index) {
      const delay = (index * 0.05) % 1;
      const duration = 0.6 + (index % 5) * 0.1;
      return {
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
        animationPlayState: this.isPlaying ? 'running' : 'paused',
      };
    },
  },
};
</script>

<style scoped lang="scss">
.audio-spectrum {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
}

.spectrum-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 120px;
  padding: 0 20px;
}

.spectrum-bar {
  width: 6px;
  height: 20%;
  background: linear-gradient(to top, var(--primary-color, #ff6600), rgba(255, 102, 0, 0.5));
  border-radius: 3px;
  animation: audioWave 0.8s ease-in-out infinite alternate;
  box-shadow: 0 0 10px rgba(255, 102, 0, 0.3);
  transform-origin: center;

  &:nth-child(1) { animation-name: audioWave1; }
  &:nth-child(2) { animation-name: audioWave2; }
  &:nth-child(3) { animation-name: audioWave3; }
  &:nth-child(4) { animation-name: audioWave4; }
  &:nth-child(5) { animation-name: audioWave5; }
  &:nth-child(6) { animation-name: audioWave6; }
  &:nth-child(7) { animation-name: audioWave7; }
  &:nth-child(8) { animation-name: audioWave8; }
  &:nth-child(9) { animation-name: audioWave1; }
  &:nth-child(10) { animation-name: audioWave2; }
  &:nth-child(11) { animation-name: audioWave3; }
  &:nth-child(12) { animation-name: audioWave4; }
  &:nth-child(13) { animation-name: audioWave5; }
  &:nth-child(14) { animation-name: audioWave6; }
  &:nth-child(15) { animation-name: audioWave7; }
  &:nth-child(16) { animation-name: audioWave8; }
  &:nth-child(17) { animation-name: audioWave8; }
  &:nth-child(18) { animation-name: audioWave7; }
  &:nth-child(19) { animation-name: audioWave6; }
  &:nth-child(20) { animation-name: audioWave5; }
  &:nth-child(21) { animation-name: audioWave4; }
  &:nth-child(22) { animation-name: audioWave3; }
  &:nth-child(23) { animation-name: audioWave2; }
  &:nth-child(24) { animation-name: audioWave1; }
  &:nth-child(25) { animation-name: audioWave8; }
  &:nth-child(26) { animation-name: audioWave7; }
  &:nth-child(27) { animation-name: audioWave6; }
  &:nth-child(28) { animation-name: audioWave5; }
  &:nth-child(29) { animation-name: audioWave4; }
  &:nth-child(30) { animation-name: audioWave3; }
  &:nth-child(31) { animation-name: audioWave2; }
  &:nth-child(32) { animation-name: audioWave1; }
}

@keyframes audioWave1 {
  0%, 100% { height: 20%; opacity: 0.6; }
  50% { height: 85%; opacity: 1; }
}

@keyframes audioWave2 {
  0%, 100% { height: 30%; opacity: 0.6; }
  50% { height: 75%; opacity: 1; }
}

@keyframes audioWave3 {
  0%, 100% { height: 40%; opacity: 0.6; }
  50% { height: 95%; opacity: 1; }
}

@keyframes audioWave4 {
  0%, 100% { height: 25%; opacity: 0.6; }
  50% { height: 70%; opacity: 1; }
}

@keyframes audioWave5 {
  0%, 100% { height: 35%; opacity: 0.6; }
  50% { height: 90%; opacity: 1; }
}

@keyframes audioWave6 {
  0%, 100% { height: 45%; opacity: 0.6; }
  50% { height: 80%; opacity: 1; }
}

@keyframes audioWave7 {
  0%, 100% { height: 28%; opacity: 0.6; }
  50% { height: 88%; opacity: 1; }
}

@keyframes audioWave8 {
  0%, 100% { height: 38%; opacity: 0.6; }
  50% { height: 78%; opacity: 1; }
}

@media (max-width: 768px) {
  .spectrum-container {
    height: 80px;
    gap: 3px;
  }

  .spectrum-bar {
    width: 4px;
  }
}

@media (max-width: 480px) {
  .spectrum-container {
    gap: 2px;
  }

  .spectrum-bar {
    width: 3px;
  }
}
</style>
